import { observable, action, reaction } from "mobx";
import phone from "./data/phone.json";
import countriesEn from "./data/countries-en.json";
import countriesIt from "./data/countries-it.json";

class CountriesStore {
  @observable countriesList = [];
  @observable phoneList = [];

  constructor() {
    this.availableCountries = { en: countriesEn, it: countriesIt };

    reaction(
      () => this.countriesList,
      countriesList => {
        this.phoneList = countriesList
          .map(c => Object.assign({}, c, { phone: phone[c.code] || "" }))
          .map(c => Object.assign({}, c, { phone: c.phone.startsWith("+") ? c.phone : `+${c.phone}` }));
      }
    );
  }

  @action
  setCountries = language => {
    this.countriesList = this.availableCountries[language || "en"];
  };

  get phoneList() {
    return this.phoneList;
  }
}

export default new CountriesStore();



// WEBPACK FOOTER //
// ./src/stores/countriesStore/index.js